import api from "api";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { checkpoints } from "component/ChecklistMeter";
import _ from "lodash";
import "./../style.scss";
import { popinfo } from "component/Fancybox/Fancybox";
import { Link } from "react-router-dom";
import { calculateProjectTimeframe } from "page/Initiative/Inside/Scaffold";
import { MaterialSymbol } from "react-material-symbols";
import update from "immutability-helper";
import PaginationWrapper from "component/Pagination";
import { DownloadResponse } from "page/Initiative/Inside/Survey";

export default connect(stateMap)((props) => {
    const [isLoading, setIsLoading]     = useState(true);
    const [parameter, setParameter]     = useState(_.assignIn({}, props.args, {
        posts_per_page: 10,
        paged: 1
    }));
    const [surveys, setSurveys] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const mergedOrigCheckpoints = _.merge({}, checkpoints.event, checkpoints.research, checkpoints.research, checkpoints.default);
    const defaultKeys           = _.keys(checkpoints.default);
    const usedCheckpoints       = _.union(
        defaultKeys
        ,_.difference(
            _.intersection(
                _.keys(checkpoints.event)
            )
            ,defaultKeys
        )
    );

    useEffect(() => {
        setParameter(update(parameter, { $merge: props.args }));
    }, [props.args])

    useEffect(() => {
        setIsLoading(true);

        Promise.all(
            [
                api('/Survey', 'get', {...parameter, is_monitoring : 1, include_initiative : 1}, 'Bearer ' + props.auth.token)
                ,api('/Survey', 'get', {...parameter, is_monitoring : 1, get_total : 1}, 'Bearer ' + props.auth.token)
            ]
        ).then(([ResponseResult, ResponseTotal]) => {
            setIsLoading(false);
            setSurveys(ResponseResult.survey);
            setTotalItems(parseInt(ResponseTotal.survey));
        })
        .catch(() => {
            setIsLoading(false);
            setSurveys([]);
            setTotalItems(0);
        })

    }, [parameter]);

    const SATPointEditor = ({ initialValue, onSave }) => {
        const [value, setValue] = useState(initialValue);

        const handleSave = () => {
            onSave(value);
        };

        return (
            <div className="flex-wrap flex v-center">
                <input
                    type="number"
                    min="0"
                    max="100"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="form-control text"
                    style={{ width: '60px', margin : 0 }}
                />&nbsp;
                <div>
                    <button 
                        className="btn btn-mini btn-orange btn-icon" 
                        onClick={handleSave}
                    >
                        <MaterialSymbol icon="save"/>
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="component-list-initiative-status component-list-monitoring">
            
            <table>
                <thead>
                    <tr>
                        <th>Survey Name</th>
                        <th>Quota</th>
                        <th>Total View</th>
                        <th>Total Respondent</th>
                        <th>Publish Status</th>
                        <th style={{ width : '120px' }}>SAT Point</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        isLoading && 
                        <tr>
                            <td colSpan={8}>
                                <span className="skeleton"></span>
                            </td>
                        </tr>
                    }
                    {
                        !isLoading && surveys.map((survey) => (
                            <tr key={survey.SurveyID} className="generic-form">
                                <td>
                                    {survey.SurveyTitle}
                                    <br/>
                                    <button className="text-xs mt-sm color-brand"  onClick={(e) => {
                                        e.preventDefault();

                                        DownloadResponse(survey, props.auth.token);

                                    }}>Export Respondent</button>&nbsp;|&nbsp;
                                    <Link to={`/initiative/${survey.Slug}/survey`}>View Initiative</Link>
                                </td>
                                
                                <td className="text-center">{survey.Quota}</td>
                                <td className="text-center">{survey.TotalView} Views</td>
                                <td className="text-center">{survey.TotalResponse} Persons</td>
                                <td>{survey.IsPublished === 1 ? 'Published' : 'Draft'}</td>
                                <td>
                                    <SATPointEditor 
                                        initialValue={survey.SATPoint} 
                                        onSave={(value) => {
                                            if (value !== undefined) {
                                                const SavingSAT = popinfo('preloader', 'Please Wait', "Saving survey SAT Point");
                                                api('/SurveySetSAT', 'post', {
                                                    survey_id : survey.SurveyID,
                                                    sat_point : value
                                                }, 'Bearer ' + props.auth.token)
                                                    .then(response => {
                                                        SavingSAT.close();
                                                    })
                                                    .catch(err => {
                                                        popinfo('preloader', 'Sorry', err, {}, SavingSAT);
                                                    })
                                            }
                                        }}
                                    />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            {!isLoading && totalItems > parameter.posts_per_page && (
                <PaginationWrapper
                    className="mt-4"
                    activePage={parameter.paged}
                    itemsCountPerPage={parameter.posts_per_page}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setParameter(update(parameter, { paged: {$set: pagenumber} }))
                    }}
                />
            )}
        </div>
    )
});